import { render, staticRenderFns } from "./CarpoolAddPaxs.vue?vue&type=template&id=200bea18&"
import script from "./CarpoolAddPaxs.vue?vue&type=script&lang=ts&"
export * from "./CarpoolAddPaxs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports